module.exports = __webpack_public_path__ + "static/media/Bigfoot.d4b0f2f6.jpg";